export const locales = ['en', 'vi'] as const;
export type Locale = (typeof locales)[number];

// Default locale
export const defaultLocale: Locale = 'vi';

// Translation cache
const translations: Record<Locale, Record<string, any>> = {
  en: {},
  vi: {}
};

export async function loadTranslations(locale: Locale) {
  if (Object.keys(translations[locale]).length === 0) {
    if (locale === 'en') {
      translations[locale] = (await import(`./locales/en.json`)).default;
    } else if (locale === 'vi') {
      translations[locale] = (await import(`./locales/vi.json`)).default;
    }
  }
  return translations[locale];
}

// Function to preload all translations at once
export async function preloadTranslations() {
  const promises = locales.map(locale => loadTranslations(locale));
  await Promise.all(promises);
  return translations;
}

export function t(key: string, locale: Locale = defaultLocale): string {
  const keys = key.split('.');
  let value = translations[locale];
  
  for (const k of keys) {
    if (!value || !value[k]) return key; // Return key if translation not found
    value = value[k];
  }
  
  return typeof value === 'string' ? value : key;
} 